import React from 'react';
import { Instagram, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-ink text-white pt-32 pb-12" data-id="element-110">
      <div className="container mx-auto px-6 md:px-12" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20" data-id="element-112">
          <div data-id="element-113">
            <div className="mb-10" data-id="element-114">
              <span className="font-heading text-3xl font-bold tracking-tight text-white block" data-id="element-115">
                Валентина
              </span>
              <span className="text-[10px] uppercase tracking-widest text-gray-400 mt-1 block" data-id="element-116">
                майстер-перукар
              </span>
            </div>

            <div className="space-y-5 text-gray-400 font-normal text-base" data-id="element-117">
              <a href="tel:+380971214358" className="flex items-center hover:text-white transition-colors w-fit" data-id="element-118">
                <Phone size={18} className="mr-4" strokeWidth={1.5} data-id="element-119" />
                +38 097 121 43 58
              </a>
              <a href="#" className="flex items-center hover:text-white transition-colors w-fit" data-id="element-120">
                <Instagram size={18} className="mr-4" strokeWidth={1.5} data-id="element-121" />
                @valentina_hair
              </a>
              <div className="flex items-center" data-id="element-122">
                <MapPin size={18} className="mr-4" strokeWidth={1.5} data-id="element-123" />
                Центральний район, м. Київ
              </div>
            </div>
          </div>

          <div className="md:flex md:justify-end" data-id="element-124">
            <div data-id="element-125">
              <h4 className="font-heading text-xl font-semibold mb-8 text-white" data-id="element-126">
                Меню
              </h4>
              <ul className="space-y-4 text-base text-gray-400 font-normal" data-id="element-127">
                <li data-id="element-128">
                  <a href="#services" className="hover:text-white transition-colors" data-id="element-129">
                    Послуги
                  </a>
                </li>
                <li data-id="element-130">
                  <a href="#courses" className="hover:text-white transition-colors" data-id="element-131">
                    Курси
                  </a>
                </li>
                <li data-id="element-132">
                  <a href="#gallery" className="hover:text-white transition-colors" data-id="element-133">
                    Мої роботи
                  </a>
                </li>
                <li data-id="element-134">
                  <a href="#about" className="hover:text-white transition-colors" data-id="element-135">
                    Про мене
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 font-normal" data-id="element-136">
          <p data-id="element-137">
            &copy; {new Date().getFullYear()} Валентина. Всі права захищені.
          </p>
          <p className="mt-4 md:mt-0" data-id="element-138">
            Сайт створено командою{' '}
            <a href="https://jetly.agency/ua" target="_blank" rel="noreferrer" className="text-white hover:text-gray-300 transition-colors font-medium underline underline-offset-4" data-id="element-139">
              jetly.agency
            </a>
          </p>
        </div>
      </div>
    </footer>;
}